// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

require('jquery')

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import Mascaras from 'javascripts/uteis/mascaras'


document.addEventListener('DOMContentLoaded', function (event) {
    console.log("DOCUMENT READ")
  
    new Mascaras().start()
});

import 'stylesheets/beeftour'
import 'stylesheets/onboardfestival'
import 'stylesheets/turnemamonasassassinas'
import 'stylesheets/piribier'
import 'stylesheets/paraisoparticular'
import 'stylesheets/veraosertanejo'
import 'stylesheets/carnaverao'
import 'stylesheets/baladapp'
import 'stylesheets/festafantasia'
import 'stylesheets/festadotim'
import 'stylesheets/festadotimsunset'
import 'stylesheets/festadotimsunrise'
import 'stylesheets/irmaos'
import 'stylesheets/camposfest'
import 'stylesheets/supercopa'
import 'stylesheets/integraoeste'




// Importando images para o DEV server
import logoVerao from '../images/veraosertanejo/logo-verao.png'
import bgAmarelo from '../images/veraosertanejo/bgamarelo.jpg'

